module.exports = __webpack_public_path__ + "static/media/family-tree-rainbow.b78f940b.svg";